"use client";

import { useTranslations } from "next-intl";

import NotFoundPage from "./NotFoundPage";

interface PropertyNotFoundPageProps {
  propertyType?: "buy" | "rent" | "developer";
}

export default function PropertyNotFoundPage({
  propertyType = "buy",
}: PropertyNotFoundPageProps) {
  const t = useTranslations();

  const getBackLink = () => {
    switch (propertyType) {
      case "buy":
        return "/buy";
      case "rent":
        return "/rent";
      case "developer":
        return "/developers";
      default:
        return "/buy";
    }
  };

  return (
    <NotFoundPage
      title={t("property_not_found")}
      backLink={getBackLink()}
      backText={t("back_to_properties")}
      homeText={t("back_to_home")}
    />
  );
}
